import React, { Component } from "react";
import { UserContext } from "context/userProvider";
import LetterLoading from "components/loading/letterLoading";
import Navigation from "components/navigation";
import Sidebar from "components/sidebar";
import "scss/screens/customers/customerList.scss";
import {
  Button,
  Form,
  Icon,
  Pagination,
  Select,
  Table,
} from "semantic-ui-react";
import NewCustomer from "components/modals/customers/newCustomer";
import NewMachine from "components/modals/customers/newMachine";
export default class CustomerList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      searchName: null,
      customerList: [],
      begin: 0,
      end: 10,
      pageSize: 10,
      activePage: 1,
      newCustomerModal: false,
      newMachineModal: false,
      model: {},
      isAlert: false,
      alertText: "",
      userID: "",
      userName: "",
    };
  }

  startLoading = () => this.setState({ isLoading: true });
  stopLoading = () => this.setState({ isLoading: false });

  setNewCustomer = () =>
    this.setState({ newCustomerModal: !this.state.newCustomerModal });
  
  setNewMachine = () =>
    this.setState({ newMachineModal: !this.state.newMachineModal });

  async componentDidMount() {
    const data = {
      team_id: -1,
      role: "",
      uid: null,
    };
    this.startLoading();
    await this.setUserData(data);
    this.stopLoading();
  }

  setUserData = async (data) => {
    await this.context.getCustomers(data);
    this.setState({
      customerList: this.context.customerList.slice(
        this.state.begin,
        this.state.end
      ),
    });
  };

  createUserSearch = () => {
    const { customerList } = this.context;
    const { searchName } = this.state;
    const userOptions = customerList?.map((user) => ({
      key: user.id,
      value: user.id,
      text: user.id,
    }));
    const userOptionsN = customerList?.map((user) => ({
      key: user.id,
      value: user.id,
      text: user.name,
    }));
    return (
      <div className="search">
        <Form>                             
          <Form.Group inline>
            <Form.Field
              control={Select}
              options={userOptions}
              value={searchName}
              placeholder="ชื่อผู้ใช้งาน"
              search
              onChange={(e, { value }) => this.setState({searchName: value })}
            />           
            <Form.Field
              control={Select}
              options={userOptionsN}
              value={searchName}
              placeholder="ชื่อ-นามสกุล"
              search
              onChange={(e, { value }) => this.setState({ searchName: value })}
            />
            <Button
              onClick={() => {
                this.setUserData({team_id: -1, role: "",uid:""});
                this.setState({
                  searchName: null,
                  level: -1,
                  begin: 0,
                  end: 10,
                  activePage: 1,
                });
              }}
            >
              รีเซต
            </Button>
            <Button
              color="blue"
              onClick={() => {
                if (this.state.searchName) {
                  this.setUserData({ team_id: 0, role: "user", uid: this.state.searchName });
                } else {
                  this.setUserData({ team_id: -1, role: "", uid: "" });
                  this.setState({
                    searchName: null,
                    level: -1,
                    begin: 0,
                    end: 10,
                    activePage: 1,
                  });
                }
              }}
            >ค้นหา
            </Button>
            &emsp;
            <Button color="teal" onClick={() => this.setNewCustomer()}>
              <Icon name="user plus" />
              เพิ่มลูกค้า
            </Button>
            <Button
              color="twitter"
              onClick={() => this.context.downloadUsers()}
            >
              <Icon name="download" />
              EXPORT FILE
            </Button>
          </Form.Group>
          <Form.Group inline>
          </Form.Group>
        </Form>
      </div>
    );
  };

  createDataTable = () => {
    const { customerList} = this.state;
    return (
      <Table celled striped selectable>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>User ID</Table.HeaderCell>
            <Table.HeaderCell>ชื่อ - นามสกุล</Table.HeaderCell>
            <Table.HeaderCell>เบอร์โทรศัพท์</Table.HeaderCell>
            <Table.HeaderCell>เพิ่มสินค้าใหม่</Table.HeaderCell>
            <Table.HeaderCell>รายละเอียดประวัติลูกค้า</Table.HeaderCell>           
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {customerList?.map((user, idx) => (
            <Table.Row key={idx}>
              <Table.Cell>{user.id}</Table.Cell>
              <Table.Cell>{user.name}</Table.Cell>
              <Table.Cell> {user.phone_no == null ? "-" : user.phone_no}</Table.Cell>

              <Table.Cell> <Button color="teal" onClick={() => {
                            this.setNewMachine();
                            this.setState({ customerDetail: user });}}>
              <Icon name="plus" /> เพิ่มสินค้า </Button> </Table.Cell>

              <Table.Cell> <Button color="twitter" href={`./customers/${user.id}`}>
                           <Icon name="file alternate outline" /> รายละเอียด </Button>
                           
              </Table.Cell>       
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    );
  };

  paginationUpdate = (e, data) => {
    const { customerList } = this.context;
    const { pageSize } = this.state;

    let beginIdx = (data.activePage - 1) * pageSize;
    let endIdx = data.activePage * pageSize;

    this.setState({ activePage: data.activePage });
    this.setState({
      customerList: [...customerList.slice(beginIdx, endIdx)],
    });
  };

  render() {
    const { isLoading, activePage, pageSize, newCustomerModal, newMachineModal, customerDetail} = this.state;
    return (
      <div className="customerList">
        <LetterLoading isOpen={isLoading} />
        <Navigation />
        <Sidebar tabActive="customersRecord" />
        <NewCustomer isOpen={newCustomerModal} isClose={this.setNewCustomer} />

        <NewMachine 
         isOpen={newMachineModal} 
         data={customerDetail} 
         isClose={this.setNewMachine} 
        />
        
        <div className="customerList-content">
          <h2>ประวัติลูกค้า</h2>
          <hr />
          <div className="customerList-content-search">
            {this.createUserSearch()}
          </div>
          <div className="customerList-content-table">
            {this.createDataTable()}
          </div>
          <div className="customerList-content-pagination">
            <Pagination
              activePage={activePage}
              totalPages={Math.ceil(
                this.context.customerList?.length / pageSize
              )}
              onPageChange={this.paginationUpdate}
            />
          </div>
        </div>
      </div>
    );
  }
}

CustomerList.contextType = UserContext;
